export const isDevMode = (): boolean => process.env.NODE_ENV === 'development';
